<template>
  <div
    id="chartdiv"
    ref="chartdiv"
    :class="{ ['not-deliverable']: _notDeliverable }"
  >
    <div class="hidden latitude">{{ latitude }}</div>
    <div class="hidden longitude">{{ longitude }}</div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// amcharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";

import markerImage from "@/assets/images/mapdot.svg";

// Themes begin
am4core.useTheme(am4themes_dark);
// Themes end

am4core.options.commercialLicense = true;

export default Vue.component("VMap", {
  props: {
    latitude: VueTypes.number,
    longitude: VueTypes.number,
    notDeliverable: VueTypes.bool.def(false)
  },

  mounted() {
    this._initialize();
  },

  data() {
    return {
      prevLatitude: this.latitude,
      prevLongitude: this.longitude
    };
  },

  computed: {
    _notDeliverable() {
      return !this.notDeliverable;
    }
  },

  methods: {
    _initialize() {
      let chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart);
      const ZOOM_LEVEL = 7;
      // Set map definition
      chart.geodata = am4worldLow;
      chart.seriesContainer.draggable = false;
      chart.seriesContainer.resizable = false;

      chart.maxZoomLevel = ZOOM_LEVEL;
      chart.minZoomLevel = ZOOM_LEVEL;

      chart.homeZoomLevel = this.latitude && this.longitude ? ZOOM_LEVEL : 1;

      if (this.latitude && this.longitude) {
        chart.homeGeoPoint = {
          latitude: this.latitude,
          longitude: this.longitude
        };
      }

      // Set projection
      chart.projection = new am4maps.projections.Miller();

      let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

      // Exclude Antartica
      polygonSeries.exclude = ["AQ"];

      // Make map load polygon (like country names) data from GeoJSON
      polygonSeries.useGeodata = true;

      // Configure series
      let polygonTemplate = polygonSeries.mapPolygons.template;
      polygonTemplate.fill = am4core.color("#ebeef0");
      polygonTemplate.stroke = am4core.color("#f6f8f9");

      // Add image series
      let imageSeries = chart.series.push(new am4maps.MapImageSeries());
      imageSeries.mapImages.template.propertyFields.longitude = "longitude";
      imageSeries.mapImages.template.propertyFields.latitude = "latitude";

      if (this.latitude && this.longitude) {
        imageSeries.data = [
          {
            latitude: this.latitude,
            longitude: this.longitude
          }
        ];
      }

      let imageSeriesTemplate = imageSeries.mapImages.template;
      let marker = imageSeriesTemplate.createChild(am4core.Image);
      marker.href = markerImage;
      marker.width = 25;
      marker.height = 25;
      marker.nonScaling = true;
      marker.horizontalCenter = "middle";
      marker.verticalCenter = "bottom";

      this.imageSeries = imageSeries;
      this.chart = chart;
      window.chart = chart;
    }
  },

  updated() {
    if (
      this.prevLatitude !== this.latitude ||
      this.prevLongitude !== this.longitude
    ) {
      this.prevLatitude = this.latitude;
      this.prevLongitude = this.longitude;
      // this.chart.animateAgain();
      this.chart.homeGeoPoint = {
        latitude: this.latitude,
        longitude: this.longitude
      };
      this.imageSeries.data = [
        {
          latitude: this.latitude,
          longitude: this.longitude
        }
      ];
      this.chart.validateDataItems();
      this.chart.goHome();
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
});
</script>

<style lang="scss" scoped>
#chartdiv {
  height: 100%;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: calc(100% - #{$sidebar-width});
  padding-left: 15%;

  &.not-deliverable {
    width: 100%;
    padding-left: 0;
  }
}
.hidden {
  visibility: hidden;
}
</style>
